import React from 'react'
import PropTypes from 'prop-types'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Checkbox from '@material-ui/core/Checkbox'

// Custom Style
import enhancedtableHeadStyle from '../../styles/jss/components/table/enhancedTableHeadStyle'


const useStyles = makeStyles(theme => enhancedtableHeadStyle(theme))

const EnhancedTableHead = props => {
    const classes = useStyles()
    const {onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, headCells} = props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>

                <TableCell padding="checkbox" className={classes.headerProperties}>
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{'aria-label': 'Select All'}}
                    />
                </TableCell>

                <TableCell padding="checkbox" className={classes.headerProperties}></TableCell>
                <TableCell className={classes.headerProperties}></TableCell>

                {headCells.map((headCell, index) => (
                    
                    <TableCell
                        className={classes.headerProperties}
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        // align={index === 0 ? 'center' : headCell.numeric ? 'right' : 'left'}


                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                            <span className={classes.visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                            ) : null}
                        </TableSortLabel>

                    </TableCell>
                ))}

            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
}


export default EnhancedTableHead